
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/ip-guideline",
      function () {
        return require("private-next-pages/docs/ip-guideline.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/ip-guideline"])
      });
    }
  